import { ActionIcon, Tooltip, useComputedColorScheme, useMantineColorScheme } from "@mantine/core";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { useAuthContext } from "@service";
import { SCOPE_TYPE } from "@model";

export default function ColorSchemeToggle() {
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme("light", { getInitialValueInEffect: true });
  const { scopes } = useAuthContext();

  if (!scopes.includes(SCOPE_TYPE.darkMode)) return null;

  const toggle = () => {
    setColorScheme(computedColorScheme === "dark" ? "light" : "dark");
  };

  return (
    <Tooltip
      label={computedColorScheme === "dark" ? "Light mode" : "Dark mode"}
      withArrow
      zIndex={1100}
    >
      <ActionIcon
        onClick={toggle}
        variant="subtle"
        size="md"
        aria-label="Toggle color scheme"
        color="gray"
      >
        {computedColorScheme === "dark" ? <IconSun size={18} /> : <IconMoon size={18} />}
      </ActionIcon>
    </Tooltip>
  );
}
